export default function setFOEAction(foe) {
    return {
        type: 'SET_FOE',
        payload: foe
    }

}